import { BigNumber } from 'bignumber.js'

import { BigNumber as BigNumber_, Schema as Schema_ } from '@blade/std-lib'

import type { TradeSettingsByNetworkListData } from '@blade/trade-api-client'

export const QuickSwapSection = Schema_.Union([
  Schema_.Literal('exploreFeeds'),
  Schema_.Literal('trendingTable'),
  Schema_.Literal('cookingTable'),
  Schema_.Literal('newPairsTable'),
  Schema_.Literal('walletsTracker'),
])

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type QuickSwapSection = Schema_.Schema.Type<typeof QuickSwapSection>

type QuickSwapDto = TradeSettingsByNetworkListData['quickAmounts']

const AmountSchema = Schema_.Struct({
  buy: BigNumber_.FromString,
  sell: BigNumber_.FromString,
})

export const Schema = Schema_.Record(QuickSwapSection, AmountSchema)

export interface QuickSwapBySection
  extends Schema_.Schema.Type<typeof Schema> {}

export interface QuickSwapSettings
  extends Schema_.Schema.Type<typeof AmountSchema> {}

export const fromDto = (dto: QuickSwapDto): QuickSwapBySection => {
  return {
    exploreFeeds: {
      buy: BigNumber(dto.exploreFeeds.buy),
      sell: BigNumber(dto.exploreFeeds.sell),
    },
    trendingTable: {
      buy: BigNumber(dto.trendingTable.buy),
      sell: BigNumber(dto.trendingTable.sell),
    },
    cookingTable: {
      buy: BigNumber(dto.cookingTable.buy),
      sell: BigNumber(dto.cookingTable.sell),
    },
    newPairsTable: {
      buy: BigNumber(dto.newPairsTable.buy),
      sell: BigNumber(dto.newPairsTable.sell),
    },
    walletsTracker: {
      buy: BigNumber(dto.walletsTracker.buy),
      sell: BigNumber(dto.walletsTracker.sell),
    },
  }
}

export const NULL_SETTINGS: QuickSwapBySection = {
  exploreFeeds: {
    buy: BigNumber(0),
    sell: BigNumber(0),
  },
  trendingTable: {
    buy: BigNumber(0),
    sell: BigNumber(0),
  },
  cookingTable: {
    buy: BigNumber(0),
    sell: BigNumber(0),
  },
  newPairsTable: {
    buy: BigNumber(0),
    sell: BigNumber(0),
  },
  walletsTracker: {
    buy: BigNumber(0),
    sell: BigNumber(0),
  },
}

export const sections: Array<QuickSwapSection> = [
  'exploreFeeds',
  'trendingTable',
  'cookingTable',
  'newPairsTable',
  'walletsTracker',
]
